import { CANCEL } from "redux-saga";
import { Ice } from "ice";
Object.assign(Ice.AsyncResult.prototype, {
    [CANCEL]() {
        this.cancel();
    },
});
const builtInOperations = [
    'ice_ping',
    'ice_isA',
    'ice_id',
    'ice_ids',
];
/**
 * Binds proxy methods.
 */
export function bindProxy(proxy) {
    const boundProxy = Object.create(proxy);
    for (const key of Object.keys(Object.getPrototypeOf(proxy))) {
        if (Ice.ObjectPrx.prototype.hasOwnProperty(key))
            continue;
        if (key.startsWith('_'))
            continue;
        if (key === 'constructor')
            continue;
        const value = boundProxy[key];
        if (typeof value !== 'function')
            continue;
        boundProxy[key] = value.bind(boundProxy);
    }
    for (const key of builtInOperations) {
        boundProxy[key] = boundProxy[key].bind(boundProxy);
    }
    return boundProxy;
}
/** @internal */
export function logError(message, e, level = 'error') {
    const args = [];
    let sagaStack = e.sagaStack;
    if (sagaStack) {
        if (e.stack)
            sagaStack = sagaStack.replace(e.stack, '');
        args.push(`${sagaStack}\n`);
    }
    args.push(e);
    console[level](`${message}\n`, ...args);
}
/** @internal */
export function getGanymedeModule() {
    const ganymede = Ice._ModuleRegistry.type('Ganymede');
    if (ganymede == null || ganymede.UserSessionPrx == null)
        throw new Error('Unable to locate `Ganymede/Glacier` slice module. ' +
            'It must be loaded into the app before Ice Client is ' +
            'created');
    return ganymede;
}
/** @internal */
export function getAuthExceptionsModule() {
    return Ice._ModuleRegistry.type('AuthExceptions');
}



//////////////////
// WEBPACK FOOTER
// ./~/@neolab/ice-client/es/utils.js
// module id = 215
// module chunks = 0